export interface MenuItem {
  icon: string;
  iconSize: number;
  lang: string;
  link: string;
  disable?: boolean;
  isShowNotify?: boolean;
}

export const menuItems: MenuItem[] = [
  {
    icon: 'mission-icon',
    lang: 'mission.title',
    link: '/mission',
    iconSize: 40,
    isShowNotify: true,
  },
  {
    icon: 'question-icon',
    lang: 'menu.issue',
    link: '/issue',
    iconSize: 40,
    isShowNotify: true,
  },
  {
    icon: 'cheeers3-icon',
    lang: 'menu.message',
    link: '/thanks',
    iconSize: 40,
  },
  {
    icon: 'note-icon',
    lang: 'menu.bulletinBoard',
    link: '/bulletin',
    iconSize: 35,
    isShowNotify: true,
  },
  {
    icon: 'graduation-hat-icon',
    lang: 'menu.eLearning',
    link: '/e-learning',
    iconSize: 40,
  },
  {
    icon: 'cash-icon',
    lang: 'menu.exchange',
    link: '/exchange',
    iconSize: 40,
  },
  {
    icon: 'settings-icon',
    lang: 'setting.title',
    link: '/setting',
    iconSize: 40,
  },
];
